import { useCallback } from 'react';

import { ControlPosition, MapControl } from '@vis.gl/react-google-maps';
import { useUserLocation } from 'core/Hooks';
import { Box } from 'ui';

import { UserLocationButton } from '../Buttons/UserLocationButton';
import { useMap } from '../context/useMapContext';

type UserLocationControlProps = {
  controlPosition: ControlPosition;
  promptForLocation?: boolean;
};

const UserLocationControl = ({ controlPosition }: UserLocationControlProps) => {
  const { setMapCenter } = useMap();
  const { getLocation, status } = useUserLocation({
    showPromptNotification: true,
    getLocationCallback: (value) => setMapCenter({ lat: value.latitude, lng: value.longitude }),
  });

  const handleClick = useCallback(async () => {
    try {
      await getLocation();
    } catch (e) {
      // Empty
    }
  }, [getLocation]);

  return (
    <MapControl position={controlPosition}>
      <Box p="md">
        <UserLocationButton onClick={handleClick} disabled={status == 'denied'} />
      </Box>
    </MapControl>
  );
};

export { UserLocationControl };
